export default theme => ({
    topDivider: {
        position: 'absolute',
        borderBottom: '1px solid ' + theme.palette.grey['300'],
        width: 'calc(100% + 120px)',
        left: -60,
        top: 60,

        '@media screen and (min-width: 600px) and (max-width: 611px)': {
            width: 'calc(100% + 60px)',
            left: -30,
            top: 45,
        },

        '@media screen and (max-width: 599px)': {
            width: 'calc(100% + 60px)',
            left: -30,
            top: 80,
        },

        '@media print and (max-width: 599px)': {
            width: 'calc(100% + 60px)',
            left: -30,
            top: 70
        }
    },

    top: {
        marginBottom: theme.spacing.unit * 7,
        marginTop: -theme.spacing.unit * 1.5,

        '@media all and (max-width: 611px)': {
            marginBottom: theme.spacing.unit * 5,
        }
    },

    brandLogo: {
        height: 37,

        "@media all and (max-width: 599px)": {
            margin: 'auto',
            height: 37,
        }
    },

    title: {
        textAlign: 'right',
        maxWidth: 330,
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
        fontSize: 14,
        textOverflow: 'ellipsis',
        lineHeight: 1.5,
        fontWeight: '100',

        '@media all and (max-width: 611px)': {
            textAlign: 'center',
            maxWidth: '100%',
        }
    },

    voucherTitle: {
        color: theme.palette.grey['600'],
        fontStyle: 'italic'
    },

    headline: {
        color: theme.palette.grey['600'],
        lineHeight: 1.3,
        paddingBottom: theme.spacing.unit * 3,
        borderBottom: '1px solid ' + theme.palette.grey['300']
    },

    cardLogo: {
        height: 75
    },

    expirationContainer: {
        position: 'relative',

        color: theme.palette.grey['300']
    },

    expirationDivider: {
        position: 'absolute',
        width: 1,
        height: 50,
        left: '50%',
        top: 30,
        backgroundColor: theme.palette.grey['300']
    },

    expirationDate: {
        color: theme.palette.grey['500'],
        marginTop: theme.spacing.unit * 2.5,
    },

    expirationDateValue: {
        fontWeight: '500',
        color: theme.palette.grey['500'],
    },

    secondExpirationDate: {
        color: theme.palette.grey['400'],
        marginTop: theme.spacing.unit * 2.5,
    },

    toPayLine: {
        color: theme.palette.grey['500'],
        marginRight: 6
    },

    secondToPayLine: {
        color: theme.palette.grey['400'],
        marginRight: 6
    },

    secondExpirationDateValue: {
        fontWeight: '500',
        color: theme.palette.grey['400'],
    },

    toPay: {
        fontSize: 28,
        fontWeight: '500',
        marginLeft: 4,
        color: theme.palette.grey['600']
    },

    surcharge: {
        fontSize: 28,
        fontWeight: '500',
        marginLeft: 4,
        color: theme.palette.grey['400']
    },

    barCodeHolder: {
        paddingBottom: theme.spacing.unit * 4,
        marginTop: theme.spacing.unit,
        borderBottom: '1px solid ' + theme.palette.grey['300'],
        "& > svg": {
            width: "100%"
        }
    },

    operationNumber: {
        color: theme.palette.grey['400'],
        marginTop: theme.spacing.unit * 2,
        marginRight: 6
    }
})
